import {
  createSurvey,
  deleteSurvey,
  editSurvey,
  deactivateSurvey,
  editSurveyStatus,
  fetchSurveyById,
  fetchSurveyEmailDomain,
  fetchSurveyResponses,
  fetchSurveys,
  fetchSurveyStatBarData,
  publishSurvey,
  resetSurveyResponsesAndStatBar,
  verifySurveyInstallation,
} from '../routines/surveyRoutines';

const initialState = {
  isLoading: false,
  isSaving: false,
  isSavingError: false,
  isVerifying: false,
  selectedSurvey: {
    isLoading: false,
  },
  selectedSurveyResponses: {
    isLoading: false,
    responses: [],
    lastFetchedKey: undefined,
  },
  selectedSurveyStatBar: {
    isLoading: false,
    data: {},
  },
  surveyList: [],
  emailDomain: {
    isLoading: false,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch (all / by ID) / edit status / delete TRIGGER survey
    case fetchSurveys.TRIGGER:
    case editSurveyStatus.TRIGGER:
    case deactivateSurvey.TRIGGER:
    case deleteSurvey.TRIGGER:
      return { ...state, isLoading: true };
    case fetchSurveyById.TRIGGER: {
      return {
        ...state,
        selectedSurvey: {
          isLoading: true,
        },
      };
    }
    case fetchSurveyEmailDomain.TRIGGER: {
      return {
        ...state,
        emailDomain: {
          isLoading: true,
        },
      };
    }

    // verify survey
    case verifySurveyInstallation.TRIGGER:
      return { ...state, isVerifying: true };
    case verifySurveyInstallation.SUCCESS:
      return { ...state, isVerifying: false };
    case verifySurveyInstallation.FAILURE:
      return { ...state, isVerifying: false };

    // fetch (all / by ID) / edit status / delete SUCCESS survey
    case fetchSurveys.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        surveyList: action.payload || [],
      };
    }
    case fetchSurveyById.SUCCESS: {
      return {
        ...state,
        selectedSurvey: {
          isLoading: false,
          ...action.payload,
        },
      };
    }
    case fetchSurveyEmailDomain.SUCCESS: {
      return {
        ...state,
        emailDomain: {
          isLoading: false,
          domain: action.payload,
        },
      };
    }
    case editSurveyStatus.SUCCESS:
    case deactivateSurvey.SUCCESS:
    case deleteSurvey.SUCCESS:
      return { ...state, isLoading: false };

    // fetch (all / by ID) / edit status / delete FAILURE survey
    case fetchSurveys.FAILURE:
    case deleteSurvey.FAILURE:
    case editSurveyStatus.FAILURE:
    case deactivateSurvey.FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case fetchSurveyById.FAILURE:
      return {
        ...state,
        selectedSurvey: {
          ...state.selectedSurvey,
          isLoading: false,
        },
      };

    case fetchSurveyEmailDomain.FAILURE:
      return {
        ...state,
        emailDomain: {
          isLoading: false,
        },
      };

    // create / edit / publish survey
    case createSurvey.TRIGGER:
    case editSurvey.TRIGGER:
    case publishSurvey.TRIGGER:
      return { ...state, isSaving: true, isSavingError: false };
    case createSurvey.SUCCESS:
    case editSurvey.SUCCESS:
    case publishSurvey.SUCCESS:
      return { ...state, isSaving: false, isSavingError: false };
    case createSurvey.FAILURE:
    case editSurvey.FAILURE:
    case publishSurvey.FAILURE:
      return { ...state, isSaving: false, isSavingError: true };

    // fetch survey responses
    case fetchSurveyResponses.TRIGGER:
      return {
        ...state,
        selectedSurveyResponses: {
          ...state.selectedSurveyResponses,
          isLoading: true,
          ...(action.payload.preservePreviousList
            ? {
                responses: state.selectedSurveyResponses.responses,
                lastFetchedKey: state.selectedSurveyResponses.lastFetchedKey,
              }
            : { responses: [], lastFetchedKey: undefined }),
        },
      };
    case fetchSurveyResponses.SUCCESS:
      return {
        ...state,
        selectedSurveyResponses: {
          isLoading: false,
          responses: action.payload.preservePreviousList
            ? [
                ...state.selectedSurveyResponses.responses,
                ...action.payload.responses,
              ]
            : action.payload.responses,
          lastFetchedKey: action.payload.lastFetchedKey,
        },
      };
    case fetchSurveyResponses.FAILURE:
      return {
        ...state,
        selectedSurveyResponses: {
          ...state.selectedSurveyResponses,
          isLoading: false,
        },
      };

    // fetch survey stat bar
    case fetchSurveyStatBarData.TRIGGER:
      return {
        ...state,
        selectedSurveyStatBar: {
          ...state.selectedSurveyStatBar,
          isLoading: true,
          data: {},
        },
      };
    case fetchSurveyStatBarData.SUCCESS:
      return {
        ...state,
        selectedSurveyStatBar: {
          isLoading: false,
          data: action.payload,
        },
      };
    case fetchSurveyStatBarData.FAILURE:
      return {
        ...state,
        selectedSurveyStatBar: {
          ...state.selectedSurveyStatBar,
          isLoading: false,
        },
      };

    // reset survey responses and stat bar data
    case resetSurveyResponsesAndStatBar.TRIGGER: {
      return {
        ...state,
        selectedSurveyResponses: {
          isLoading: false,
          responses: [],
          lastFetchedKey: undefined,
        },
        selectedSurveyStatBar: {
          isLoading: false,
          data: {},
        },
      };
    }

    default:
      return state;
  }
};
